const servicegroup = (state = [], action) => {
    switch (action.type) {
      case 'DETAILSMANAGER':
      return {
        type: "DETAILSMANAGER",
        json: action.json
      }
      default:
        return state
    }
  }
  
  export default servicegroup